import { styled } from "@vitality-ds/system";
import IconButtonCell from "../IconButton";
import BaseIconButtonCellStyles from "./styles/BaseIconButtonCell.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseIconButtonCell = styled(IconButtonCell, BaseIconButtonCellStyles);